import React, { ReactNode } from "react";

export default function({ children }: {children: ReactNode}) {
    return (
        <ul className="list">
            {children}
        </ul>
    )
}